import { render, staticRenderFns } from "./PaymentGroupModal.vue?vue&type=template&id=d46870ee"
import script from "./PaymentGroupModal.vue?vue&type=script&lang=js"
export * from "./PaymentGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports